import { useState } from "react";
import { useNavigate } from "react-router";
import { useDispatch } from "react-redux";
import Dropdown from "react-bootstrap/Dropdown";
import DropdownButton from "react-bootstrap/DropdownButton";
import SwitchVertical01 from "@untitled-ui/icons-react/build/esm/SwitchVertical01";
import { FaSearch } from "react-icons/fa";
import { TrashIcon } from "../../../../../assets/icons";
import { formatDate } from "../../../../utils/_generic";
import PDLTypography from "../../../components/dna/_pdltypography";
import { SortOrder } from "../../../components/_saveDateFilter";
import { Pagination } from "../../../components/global";
import {
  doSearch,
  SEARCH_TYPES,
} from "../../../../store/reducer/_searchReducer";
import "./index.scss";

interface SavedSearch {
  id: string;
  tipo: string;
  termo: string;
  filtros?: {
    categoria?: string;
    ano?: string;
    tipo_doc?: string;
    [key: string]: any;
  };
  createdAt: string;
}

interface SavedSearchesListProps {
  searches: SavedSearch[];
  onDeleteAll?: () => void;
  onDelete?: (id: string) => void;
  onSortChange?: (order: SortOrder) => void;
}

const SavedSearchesList = ({
  searches,
  onDeleteAll,
  onDelete,
  onSortChange,
}: SavedSearchesListProps) => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [sortOrder, setSortOrder] = useState<SortOrder>("desc");

  const handleSortChange = (order: SortOrder) => {
    setSortOrder(order);
    onSortChange?.(order);
  };

  const handleSearch = (search: SavedSearch) => {
    if (!search.termo) {
      return;
    }

    // @ts-ignore
    dispatch(doSearch({ query: search.termo, searchType: SEARCH_TYPES.all }));
    navigate("/resultados");
  };

  const sortedSearches = [...searches].sort((a, b) => {
    if (sortOrder === "asc") {
      return new Date(a.createdAt).getTime() - new Date(b.createdAt).getTime();
    } else if (sortOrder === "desc") {
      return new Date(b.createdAt).getTime() - new Date(a.createdAt).getTime();
    }
    return 0;
  });

  return (
    <div className="saved-searches-list">
      <div className="saved-searches-header">
        <button type="button" className="btn-delete-all" onClick={onDeleteAll}>
          <TrashIcon color="#8c0000" />
          <span>Apagar pesquisas salvas</span>
        </button>

        <DropdownButton
          variant="outline-secondary"
          title={
            <>
              <SwitchVertical01 className="me-2" />
              {sortOrder === "desc" ? "Mais recentes" : "Mais antigos"}
            </>
          }
          id="dropdown-sort-options"
        >
          <Dropdown.Item onClick={() => handleSortChange("desc")}>
            Mais recentes
          </Dropdown.Item>
          <Dropdown.Item onClick={() => handleSortChange("asc")}>
            Mais antigos
          </Dropdown.Item>
        </DropdownButton>
      </div>

      {sortedSearches.length === 0 ? (
        <PDLTypography size="sm" className="text-muted mt-4">
          Nenhuma pesquisa salva encontrada
        </PDLTypography>
      ) : (
        <div className="saved-searches-table">
          <div className="table-header">
            <div className="header-cell">Pesquisa</div>
            <div className="header-cell header-cell-center">
              Tipo de pesquisa
            </div>
            <div className="header-cell header-cell-center">
              Data da pesquisa
              {sortOrder === "desc" ? "↓" : sortOrder === "asc" ? "↑" : ""}
            </div>
            <div className="header-cell"></div>
          </div>

          {sortedSearches.map((search) => (
            <div key={search.id} className="table-row">
              <div className="table-cell">{search.termo}</div>
              <div className="table-cell table-cell-center">
                {search.tipo || "Tudo"}
              </div>
              <div className="table-cell table-cell-center">
                {formatDate(search.createdAt)}
              </div>
              <div className="table-cell table-cell-actions">
                <button
                  type="button"
                  className="btn-delete-item"
                  onClick={() => onDelete?.(search.id)}
                  title="Excluir pesquisa"
                >
                  <TrashIcon color="#8c0000" />
                </button>
                <button
                  type="button"
                  className="btn-action-item"
                  onClick={() => handleSearch(search)}
                  title="Realizar pesquisa"
                >
                  <FaSearch color="#344054" />
                </button>
              </div>
            </div>
          ))}
        </div>
      )}
      {sortedSearches.length > 0 && (
        <div className="mt-4">
          <Pagination
            currentPage={1}
            totalPages={20}
            onPageChange={() => {}}
            showFirstLast={true}
            showPrevNext={true}
            maxVisiblePages={5}
            size="md"
          />
        </div>
      )}
    </div>
  );
};

export default SavedSearchesList;
